import React from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import { Redirect, useHistory } from 'react-router-dom';
import NormalInput from "../../components/common/input/NormalInput";
import { Link } from "react-router-dom";
import TextArea from '../../components/common/textarea/TextArea';
import { addConsultAction, setAddConsultResultResetAction } from "../../modules/cs/customserviceModule";
import LoadingOverlay from 'react-loading-overlay';
import NormalPopupOneBtn, { NomalPopupOneBtnStyles } from "../../components/common/popup/NormalPopupOneBtn";
import Modal from 'react-modal';
import { EnCryptData, DeCryptData } from '../../lib/util/CustomUtil';

const ConsultBlock = styled.div`
    min-width: 1236px; 
`;

const ConsultContainerBlock = styled.div`
    padding-top: 80px;
`;

const ConstultWrapClearfix = styled.div`
    //width: 100%;
    width: 1176px;
    margin: 0 auto;
    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const ConsultCSLeftLinkBlock = styled.div`
    left: 0;
    position: absolute;
    top: 0;
    color: #999;
    font-size: 20px;
    font-weight: 500;

    ::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 16px;
        margin-right: 20px;
        background: url(/assets/images/icon/faq_arrow-icon.png) center center/cover no-repeat;
    }
`;

const ConsultCStitleH2Block = styled.h2`
    font-size: 32px;
    font-weight: 500;
    text-align: center;

    ::before {
        content: '';
        display: inline-block;
        width: 43px;
        height: 37px;
        margin-right: 20px;
        background: url(/assets/images/icon/consult-icon.svg) center center/auto no-repeat;
        vertical-align: -4px;
    }
`;

const ConsultCSRightLinkBlock = styled.div`
    right: 0;
    position: absolute;
    top: 0;
    color: #999;
    font-size: 20px;
    font-weight: 500;

    ::after {
        content: '';
        display: inline-block;
        width: 8px;
        height: 16px;
        margin-left: 20px;
        background: url(/assets/images/icon/faq_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }
    
    
`;

const ConsultFormSeletBtnBlock = styled.button`
    float: left;
    width: 150px;

    float: left;
    //width: 50%;
    height: 40px;
    border: 1px solid #ccc;
    border-right: ${props => props.rBorder || '#none'};//none; //1px solid #ccc
    font-size: 14px;

    color: ${props => props.color || '#333'};
    background-color: ${props => props.bgColor || 'transparent'};
`;

const ConsultFileLabelBlock = styled.label`

    ::after {
        content: '';
        display: ${props => props.display};
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        width: 16px;
        height: 16px;
        background: url(/assets/images/icon/file-icon.png) center center/cover no-repeat;
    }
`;

const ConsultImageBlock = styled.div`
    background-image : url(${props => props.backgroundimage});

`;

const ConsultPagePBlock = styled.p`
    line-height: 1.3;
    width: 100%;
    color: #666;
    font-size: 12px;
    word-break: keep-all;
    text-align: right;
`;

const ConsultSubmitButtonBlock = styled.button`
    pointer-events: ${props => props.disable};
    background-color: ${props => props.colorF};
    border: 1px solid ${props => props.colorF};
`;

const StyleLoader = styled(LoadingOverlay)`

    padding:0px;
    margin : 0px;

  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

const BuyOption = [
    { value: "125301", label: "배송" },
    { value: "125302", label: "주문" },
    { value: "125303", label: "결제" },
    { value: "125304", label: "교환" },
    { value: "125305", label: "반품" },
    { value: "125306", label: "취소" },
];

const NormalOption = [
    { value: "125401", label: "견적" },
    { value: "125402", label: "상품" },
    { value: "125403", label: "회원" },
    { value: "125404", label: "시스템 장애" },
    { value: "125405", label: "증빙서류" },
    { value: "125406", label: "기타" },
];

const MAX_FILE_SIZE = 2 * 1000 * 1000;

const ConsultMain = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [curSelValue, setCurSelValue] = useState("125301");
    const [curTitle, setCurTitle] = useState("");
    const [curContent, setCurContent] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [modalMsg, setModalMsg] = useState(null);
    /*  //const image1Ref = useRef(null);
     const [imgBase64, setImgBase64] = useState(""); // 파일 base64
     const [imgFile, setImgFile] = useState(null);	//파일
     //const [imgUrl, setImgUrl]=useState(null);
 
     const [count, setCount]= useState(0); */

    const imageRef = useRef([React.createRef(), React.createRef(), React.createRef()])
    const [imgUrl1, setImgUrl1] = useState(null);
    const [imgUrl2, setImgUrl2] = useState(null);
    const [imgUrl3, setImgUrl3] = useState(null);

    const [imgFile1, setImgFile1] = useState(null);
    const [imgFile2, setImgFile2] = useState(null);
    const [imgFile3, setImgFile3] = useState(null);

    const [curSeltImangIndex, setCurSeltImangIndex] = useState(0);

    useEffect(() => {
        dispatch(setCurMenuAction('consult'));
        dispatch(setHeaderTransferAction(false));
        window.scrollTo(0, 0);
    }, [])

    const { accessToken, id, brandSelFilterIndex, loading, resultAddConsult, error } = useSelector(
        ({ userReducer, brandItemsReducer, loadingReducer, customserviceReducer }) => ({
            accessToken: userReducer.accessToken,
            id: userReducer.id,
            brandSelFilterIndex: brandItemsReducer.brandSelFilterIndex,
            loading: loadingReducer['customservice/ADD_CONSULT'],
            resultAddConsult: customserviceReducer.resultAddConsult,
            error: customserviceReducer.error,
        })
    );

    useEffect(() => {
        if (resultAddConsult !== null && resultAddConsult.code === 200) {
            setModalMsg("1:1 문의가 등록되었습니다.\n[ 마이페이지 ] > [ 문의 내역 ] 에서\n 답변을 확인해주세요.");
            setOpenModal(true);
            dispatch(setAddConsultResultResetAction());
        }
        else if (error !== null && resultAddConsult !== null) {
            alert("업로드 중 문제가 발생하였습니다. 다시 시도해 주세요.")
            dispatch(setAddConsultResultResetAction());
        }

    }, [resultAddConsult])

    useEffect(() => {

        //#2530 history back 위치 저장되어 있는 경우 처리
        if (accessToken === null) {
            return history.replace("/login",{ from: history.location })

        }
    }, [])

/*     if (accessToken === null) {
        return history.push("/login");
    } */

    const onClickSelBtn = (value) => {
        //console.log("onClickSelBtn=" + value)
        setCurSelValue(value);
    }

    const hanldeTitleInput = (e) => {
        // console.log("hanldeTitleInput : " + e.target.value);
        setCurTitle(e.target.value);

    }

    const handleContentInput = (e) => {
        // console.log("Question : " + e.target.value);
        setCurContent(e.target.value);

    }

    //이미지 새창 띄우기
    function image_popup(url) {

        var imgObj = new Image();
        imgObj.src = url;
        const y = window.top.outerHeight / 2 + window.top.screenY - (710 / 2);
        const x = window.top.outerWidth / 2 + window.top.screenX - (1096 / 2);

        imgObj.onload = function () {
            let height = this.height;
            let width = this.width;
            let top = (710 - height) / 2;
            let left = (1096 - width) / 2;
            if (top < 0) {
                top = 0;
            }
            if (left < 0) {
                left = 0;
            }
            //console.log("image popup height = " + height)
            //console.log("image popup width = " + width)
            let imageWin = window.open("", url, "width=1096px, height=710px" + ", top=" + y + " , left=" + x);

            //console.log("img = " + JSON.stringify(imgObj))
            imageWin.document.write("<html><body style='margin:0'>");
            imageWin.document.write("<div style='width: 1096px;height: 710px;'><a href=javascript:window.close()><img style='max-width: 1096px; padding: auto; margin: 0;position: absolute;top:" + top + "px;" + " left:" + left + "px;" + "' align=center src='" + imgObj.src + "' border=0></a></div>");
            imageWin.document.write("</body><html>");
            imageWin.document.title = imgObj.src;
        }

    }

    // + 이미지 선택 시에 파일 선택창 보이기
    const onClickImage = (index) => {
        if (index === 0 && imgUrl1 !== null) {
            return image_popup(imgUrl1);
        }
        if (index === 1 && imgUrl2 !== null) {
            return image_popup(imgUrl2);
        }
        if (index === 2 && imgUrl3 !== null) {
            return image_popup(imgUrl3);
        }

        setCurSeltImangIndex(index);
        //console.log("onClickImage1 : " + index);
        if (imageRef.current[index].current) {
            imageRef.current[index].current.click();
        }
    }

    const checkFileSize = (event) => {
        let files = event.target.files;
        let size = MAX_FILE_SIZE;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            //console.log("checkFileSize = "+files[x].size);
            if (files[x].size > size) {
                err += files[x].type + 'is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            event.target.value = null;
            //console.log(err);
            return false;
        }

        return true;

    }

    const handleChangeFile = (event) => {
        let reader = new FileReader();
        // console.log("handleChangeFile : " + event.target.files[0]);

        if (checkFileSize(event) === false) {
            alert('2MB 이하의 이미지만 첨부가능합니다.');
            return;
        }

        reader.onloadend = () => {
            // 2. 읽기가 완료되면 아래코드가 실행됩니다.
            /* const base64 = reader.result;
            if (base64) {
              setImgBase64(base64.toString()); // 파일 base64 상태 업데이트
            } */
            //console.log("url="+reader.result);
            //console.log("curSeltImangIndex="+curSeltImangIndex);
            if (curSeltImangIndex === 0) {
                setImgUrl1(reader.result);
            }
            else if (curSeltImangIndex === 1) {
                setImgUrl2(reader.result);
            }
            else {
                setImgUrl3(reader.result);
            }

        }
        if (event.target.files[0]) {
            var url = reader.readAsDataURL(event.target.files[0]); // 1. 파일을 읽어 버퍼에 저장합니다.
            //console.log("url="+event.target.files[0].name);
            //setImgFile(event.target.files[0]); // 파일 상태 업데이트

            if (curSeltImangIndex === 0) {
                setImgFile1(event.target.files[0]);
            }
            else if (curSeltImangIndex === 1) {
                setImgFile2(event.target.files[0]);
            }
            else {
                setImgFile3(event.target.files[0]);
            }
        }
    }

    const handleSubmit = (event) => {
        //console.log("handleSubmit=");
        event.preventDefault();

        if (curTitle && curTitle.length > 0 && curContent && curContent.length > 0) {
            event.preventDefault();
            const formData = new FormData();
            formData.append('cnslt_type', curSelValue);
            formData.append('title', curTitle);
            let paramdata = { id };
            formData.append('user_email', EnCryptData(JSON.stringify(paramdata)));
            formData.append('question', curContent);


            if (imgFile1) {
                //console.log("handleSubmit=imag1");
                formData.append('img', imgFile1);
            }
            if (imgFile2) {
                formData.append('img', imgFile2);
            }
            if (imgFile3) {
                formData.append('img', imgFile3);
            }

            dispatch(addConsultAction(formData));
        }

        return false;
    }

    const getCount = () => {
        let countimge = 0;
        if (imgUrl1) countimge++;
        if (imgUrl2) countimge++;
        if (imgUrl3) countimge++;

        return countimge;
    }

    const isDiableSubmit = () => {

        if (curTitle && curTitle.length > 0 && curContent && curContent.length > 0) {
            return false;
        }
        return true;

    }

    // 팝업 클릭 
    const handlePopupClick = () => {
        setOpenModal(false);
        window.location.reload(false);
    }

    return (
        <ConsultBlock>
            <StyleLoader
                active={loading}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                <Header />
                <ConsultContainerBlock>

                    <form onSubmit={handleSubmit}>
                        <div className="mypage-section">
                            <ConstultWrapClearfix>
                                <div className="cs_title-wrap margin_b-60">
                                    <Link to={"/faq"}><ConsultCSLeftLinkBlock> 자주 찾는 질문</ConsultCSLeftLinkBlock></Link>
                                    <ConsultCStitleH2Block>1 : 1 문의</ConsultCStitleH2Block>
                                    <Link to={"/notice"}><ConsultCSRightLinkBlock>공지 알리미</ConsultCSRightLinkBlock></Link>
                                </div>
                                <div className="default-table">
                                    <h3 className="dt-title">1:1 문의 글 남기기</h3>
                                    <table className="table-info-box margin_b-20">
                                        <tbbody>
                                            <tr>
                                                <td className="border_bottom">
                                                    <div className="input-box">
                                                        <div className="margin_b-0">
                                                            <div className="input_title-box margin_b-20 f-left clearfix">
                                                                <label className="input-title f-left">구매문의</label>
                                                                <div className="input-content f-left">
                                                                    <div className="fixed_btn-box">
                                                                        {
                                                                            BuyOption.map((item, index) => {
                                                                                //console.log("item = "+item.value);
                                                                                //console.log("curSelValue = "+curSelValue);            
                                                                                return (
                                                                                    <ConsultFormSeletBtnBlock type="button" key={item.value}
                                                                                        bgColor={item.value === curSelValue ? '#ffe7ad' : 'transparent'}
                                                                                        color={item.value === curSelValue ? '#333' : '#999'}
                                                                                        onClick={() => onClickSelBtn(item.value)}
                                                                                        rBorder={index === BuyOption.length - 1 ? '1px solid #ccc' : 'none'}>
                                                                                        {item.label}
                                                                                    </ConsultFormSeletBtnBlock>

                                                                                );
                                                                            })
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input_title-box margin_b-20 f-left clearfix">
                                                                <label className="input-title f-left">일반문의</label>
                                                                <div className="input-content f-left">
                                                                    <div className="fixed_btn-box">
                                                                        {
                                                                            NormalOption.map((item, index) => {
                                                                                //console.log("item = "+item.value);
                                                                                //console.log("curSelValue = "+curSelValue);            
                                                                                return (
                                                                                    <ConsultFormSeletBtnBlock type="button" key={item.value}
                                                                                        bgColor={item.value === curSelValue ? '#ffe7ad' : 'transparent'}
                                                                                        color={item.value === curSelValue ? '#333' : '#999'}
                                                                                        onClick={() => onClickSelBtn(item.value)}
                                                                                        rBorder={index === NormalOption.length - 1 ? '1px solid #ccc' : 'none'}>
                                                                                        {item.label}
                                                                                    </ConsultFormSeletBtnBlock>

                                                                                );
                                                                            })
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input_title-box margin_b-20 f-left clearfix">
                                                                <label className="input-title f-left">제목</label>
                                                                <div className="input-content f-left">
                                                                    <div style={{ width: '900px' }}>
                                                                        <NormalInput type="text" maxLength="100" marginBottom="0px"
                                                                            placeholder="제목을 입력해 주세요." width="900px" float="right" marginInnerTop="0px"
                                                                            onChange={hanldeTitleInput} dispError={false} />

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input_title-box margin_b-20 f-left clearfix">
                                                                <label className="input-title f-left">내용</label>
                                                                <div className="input-content f-left">
                                                                    <div style={{ width: '900px' }}>
                                                                        <TextArea placeholder="문의하실 내용을 자세히 입력해 주세요."
                                                                            height="160px" onChange={handleContentInput} />

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input_title-box margin_b-10 f-left clearfix">
                                                                <label className="input-title f-left">파일 첨부</label>
                                                                <div className="input-content f-left">
                                                                    <div className="f-left clearfix" style={{ width: '900px' }}>
                                                                        <ConsultImageBlock className="file_img-thumb f-left " backgroundimage={imgUrl1}>
                                                                            <input type="file" accept="image/png,image/gif,image/jpeg" className="blind" ref={imageRef.current[0]} onChange={handleChangeFile}></input>
                                                                            <ConsultFileLabelBlock className="file-label" display={imgUrl1 ? "none" : "block"} onClick={() => onClickImage(0)} />
                                                                        </ConsultImageBlock>
                                                                        <ConsultImageBlock className="file_img-thumb f-left margin_l-10" backgroundimage={imgUrl2}>
                                                                            <input type="file" accept="image/png,image/gif,image/jpeg" className="blind" ref={imageRef.current[1]} onChange={handleChangeFile}></input>
                                                                            <ConsultFileLabelBlock className="file-label" display={imgUrl2 ? "none" : "block"} onClick={() => onClickImage(1)} />
                                                                        </ConsultImageBlock>
                                                                        <ConsultImageBlock className="file_img-thumb f-left margin_l-10" backgroundimage={imgUrl3}>
                                                                            <input type="file" accept="image/png,image/gif,image/jpeg" className="blind" ref={imageRef.current[2]} onChange={handleChangeFile}></input>
                                                                            <ConsultFileLabelBlock className="file-label" display={imgUrl3 ? "none" : "block"} onClick={() => onClickImage(2)} />
                                                                        </ConsultImageBlock>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <ConsultPagePBlock className="info text_right" style={{ width: '450px' }}><b>{getCount()}</b>/최대 3개</ConsultPagePBlock>
                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbbody>
                                    </table>
                                    <div className="text_center">
                                        <ConsultSubmitButtonBlock type="submit" className="mh-btn black-btn"
                                            disable={isDiableSubmit() ? "none" : ""} colorF={isDiableSubmit() ? "#e0e0e0" : "#111"}>
                                            등록하기
                                        </ConsultSubmitButtonBlock>
                                    </div>
                                </div>
                            </ConstultWrapClearfix>
                        </div>
                    </form>




                </ConsultContainerBlock>

                <Footer />
            </StyleLoader>
            <Modal
                isOpen={openModal}
                onRequestClose={handlePopupClick}
                style={NomalPopupOneBtnStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopupOneBtn
                    text=""
                    text2={modalMsg} text3=""
                    btn="확인" onClick={handlePopupClick} />
            </Modal>
        </ConsultBlock>
    );
};

export default ConsultMain;